import { useEffect, useMemo, useRef } from 'react';
import { Gomb } from '../ui/elemek.tsx';
import { KEP_MAX_DB, KEP_TIPUSOK } from './kepek.ts';

/** Csatolt képek előnézettel és törléssel. A fájlok állapotát a hívó tartja; a kiválasztás és beillesztés a `onHozzaad`-on át megy. */
export default function KepValaszto({ fajlok, onHozzaad, onTorol, hiba, tiltva }: {
  fajlok: File[]; onHozzaad(uj: File[]): void; onTorol(index: number): void; hiba: string | null; tiltva: boolean;
}) {
  const bemenet = useRef<HTMLInputElement>(null);
  const elonezetek = useMemo(() => fajlok.map((f) => URL.createObjectURL(f)), [fajlok]);
  useEffect(() => () => { for (const u of elonezetek) URL.revokeObjectURL(u); }, [elonezetek]);

  return (
    <div className="grid gap-2">
      <span className="text-sm text-szoveg-halk">Képek (nem kötelező)</span>
      {fajlok.length > 0 && (
        <ul aria-label="Csatolt képek" className="grid grid-cols-3 gap-2 sm:grid-cols-5">
          {fajlok.map((f, i) => (
            <li key={`${f.name}-${f.size}-${f.lastModified}-${i}`} className="relative aspect-square overflow-hidden rounded-xl border border-vonal bg-hatter-melyen">
              <img src={elonezetek[i]} alt={f.name || `Csatolt kép ${i + 1}`} className="size-full object-cover" />
              <button
                type="button"
                disabled={tiltva}
                aria-label={`Kép törlése: ${f.name || i + 1}`}
                onClick={() => onTorol(i)}
                className="absolute top-1 right-1 grid size-8 place-items-center rounded-full bg-hatter-melyen/90 text-szoveg hover:text-hiba"
              >
                <span aria-hidden>×</span>
              </button>
            </li>
          ))}
        </ul>
      )}
      <div className="flex flex-wrap items-center gap-3">
        <input
          ref={bemenet}
          type="file"
          accept={KEP_TIPUSOK.join(',')}
          multiple
          hidden
          data-testid="hiba-kep-bemenet"
          onChange={(e) => { onHozzaad(Array.from(e.target.files ?? [])); e.target.value = ''; }}
        />
        <Gomb valtozat="masodlagos" disabled={tiltva || fajlok.length >= KEP_MAX_DB} onClick={() => bemenet.current?.click()}>Kép csatolása</Gomb>
        <span className="text-sm text-szoveg-halk">{fajlok.length} / {KEP_MAX_DB} · PNG, JPEG vagy WebP, legfeljebb 5 MB · beillesztheted vágólapról is</span>
      </div>
      {hiba && <p role="alert" className="text-sm text-hiba">{hiba}</p>}
    </div>
  );
}
